import React, { useState } from "react";
import { BrowserRouter as Router, Route,Switch,Redirect } from "react-router-dom";
import Login from "./components/Login";
import Registration from "./components/Registration";
import ForgotUserName from "./components/ForgotUserName";
import PasswordReset from "./components/PasswordReset";
import ResendVerificationEmail from "./components/ResendVerificationEmail";
import VerificationSuccess from "./components/VerificationSuccess";
import Profile from "./components/Profile";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { getRoutePath } from "./utils/common";
import SomethingWentWrong from "./components/common/SomethingWentWrong";
import IdVerification from "./components/IdVerification";
import IdVerify from "./components/IdVerify";
import Preview from "./components/Preview";

function Routes() {
  const [userDetails, setUserDetails] = useState({});
  return (
    <Router>
      <Header userDetails={userDetails} />
      <Switch>
      <Route path="/" component={Login} exact />
      <Route path={`${getRoutePath}`} component={Login} exact />
      <Route path={`${getRoutePath}/login`} component={Login} userDetails={userDetails} />
      <Route path={`${getRoutePath}/registration`} component={Registration} />
      <Route path={`${getRoutePath}/idverification`} component={IdVerification} />
      <Route path={`${getRoutePath}/level2verification`} component={IdVerify} />
      <Route path={`${getRoutePath}/preview`} component={Preview} />
      <Route
        path={`${getRoutePath}/forgotusername`}
        component={ForgotUserName}
      />
      <Route path={`${getRoutePath}/passwordreset`} component={PasswordReset} />
      <Route
        path={`${getRoutePath}/resendVerificationEmail`}
        component={ResendVerificationEmail}
      />
      <Route
        path={`${getRoutePath}/verificationSuccess`}
        component={VerificationSuccess}
      />
      <Route
        path={`${getRoutePath}/profile/:pageName?`}
        render={(props) => (
          <Profile {...props} setUserDetails={setUserDetails} />
        )}
      />
      <Route component={SomethingWentWrong} />
      </Switch>
      <Footer />
    </Router>
  );
}

export default Routes;
